import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.array.for-each";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { createContext, createElement, useCallback, useEffect, useRef, useState } from 'react'; // -------------------------------------------------------
// context
// -------------------------------------------------------

export var STATE_CONTEXT_PROPERTY = 's';
export var VERSION_CONTEXT_PROPERTY = 'v';
export var UPDATE_CONTEXT_PROPERTY = 'u';
export var SUBSCRIBE_CONTEXT_PROPERTY = 'b';
var WARNING_MESSAGE = 'Please use <Provider>';
var warningObject = {
  get s
  /* [STATE_CONTEXT_PROPERTY] */
  () {
    throw new Error(WARNING_MESSAGE);
  },

  get u
  /* [UPDATE_CONTEXT_PROPERTY] */
  () {
    throw new Error(WARNING_MESSAGE);
  }

};

var calculateChangedBits = function calculateChangedBits(a, b) {
  return a[UPDATE_CONTEXT_PROPERTY] !== b[UPDATE_CONTEXT_PROPERTY] || a[SUBSCRIBE_CONTEXT_PROPERTY] !== b[SUBSCRIBE_CONTEXT_PROPERTY] ? 1 : 0;
};

export var createCustomContext = function createCustomContext() {
  var w = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : warningObject;
  var c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : calculateChangedBits;
  return createContext(w, c);
}; // -------------------------------------------------------
// provider
// -------------------------------------------------------

export var createProvider = function createProvider(context, useValue) {
  var Provider = function Provider(props) {
    var _value;

    var _useValue = useValue(props),
        _useValue2 = _slicedToArray(_useValue, 2),
        state = _useValue2[0],
        update = _useValue2[1];

    var _useState = useState(0),
        _useState2 = _slicedToArray(_useState, 2),
        version = _useState2[0],
        setVersion = _useState2[1];

    var versionRef = useRef(0);
    var listeners = useRef([]);
    var updateAndNotify = useCallback(function () {
      versionRef.current += 1;
      listeners.current.forEach(function (listener) {
        return listener(versionRef.current);
      });
      setVersion(versionRef.current);
      return update.apply(void 0, arguments);
    }, [update]);
    useEffect(function () {
      versionRef.current += 1;
      listeners.current.forEach(function (listener) {
        return listener(versionRef.current, state);
      });
      setVersion(versionRef.current);
    }, [state]);
    var subscribe = useCallback(function (listener) {
      listeners.current.push(listener);

      var unsubscribe = function unsubscribe() {
        var index = listeners.current.indexOf(listener);
        listeners.current.splice(index, 1);
      };

      return unsubscribe;
    }, []);
    return createElement(context.Provider, {
      value: (_value = {}, _defineProperty(_value, STATE_CONTEXT_PROPERTY, state), _defineProperty(_value, VERSION_CONTEXT_PROPERTY, version), _defineProperty(_value, UPDATE_CONTEXT_PROPERTY, updateAndNotify), _defineProperty(_value, SUBSCRIBE_CONTEXT_PROPERTY, subscribe), _value)
    }, props.children);
  };

  return Provider;
};